import { Plus } from "lucide-react";

import CustomButton from "@/components/desktop/button/CustomButton";
import MemberForm from "./MemberForm";
import styles from "./MemberForm.module.scss";

const MembersSection = ({ members, onAdd, onUpdate, onRemove, errors }) => {
	return (
		<div className={styles.section}>
			<div className={styles.headerBar}>
				<h4 className={styles.title}>Contactos</h4>
			</div>

			{errors.members && <p className={styles.error}>{errors.members}</p>}

			<div className={styles.table}>
				<div className={styles.headerRow}>
					<span>Nombre</span>
					<span>Correo</span>
					<span>Teléfono</span>
					<span></span>
				</div>

				{(members || []).map((member, index) => {
					const memberError = errors[`member_${index}`];
					const key = member.id || member.temp_id || index;

					return <MemberForm key={key} member={member} index={index} onUpdate={onUpdate} onRemove={onRemove} error={memberError} />;
				})}
			</div>

			<div className={styles.buttonContainer}>
				<CustomButton variant="secondary" startIcon={<Plus size={16} />} onClick={onAdd}>
					Agregar Contacto
				</CustomButton>
			</div>
		</div>
	);
};

export default MembersSection;
